<script setup>
// Publisher pages: brand-attribute catalog. All logic lives in the shared
// EntityCatalog component (also used by /license).
</script>

<template>
  <EntityCatalog entity="publisher" />
</template>
